import CoreBase from '../../../../services/engines/CoreBase';

class SectionInjector extends CoreBase {
    _name = 'SectionInjector';

    /**
     * Injects templateJson.sections into the HTML shell as const sections.
     * Replaces the const sections = []; placeholder in the shell.
     * @param {string} html
     * @param {object} templateJson
     * @returns {string} html with sections injected
     */
    inject(html, templateJson) {
        if (!templateJson?.sections?.length) return html;

        return html.replace(
            /const sections = \[\];/,
            `const sections = ${JSON.stringify(templateJson.sections)};`,
        );
    }
}

const sectionInjector = new SectionInjector();
export default sectionInjector;
